import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ULI_ORIGIN_UI_TITLE_BY_ORIGIN } from '../../common/constants/uli';
import { MonitoringFilterAdjustUiPipe } from '../../common';
import { PipesModule } from '../../common/pipes/pipes.module';

@Component({
  selector: 'ui-acronym-icon',
  imports: [CommonModule, PipesModule, MatTooltipModule],
  templateUrl: './acronym-icon.component.html',
  styleUrls: ['./acronym-icon.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AcronymIconComponent implements OnInit {
  @Input() set text(text: string) {
    if (text) {
      this.origin = ULI_ORIGIN_UI_TITLE_BY_ORIGIN[text] || text;
    }
  }

  @Input() tooltip?: string;
  @Input() sapClientData?: boolean;
  origin: string = null;
  sapDetails: string;

  constructor(public monitoringFilterAdjustUiPipe: MonitoringFilterAdjustUiPipe) {}

  ngOnInit(): void {
    this.sapDetails = this.monitoringFilterAdjustUiPipe.transform(this.origin);
    this.sapDetails = this.sapDetails + ' ' + this.tooltip;
  }
}
